import Constants from 'utils/Constants.js'
import { formatTime } from 'utils/FormatDateTime.js'
import GetBreakpoint from 'utils/GetBreakpoint.js'
import { getDistanceToTopOfPage } from 'utils/GetDistanceToTopOfPage.js'
import { getFixedAndStickyHeight } from 'utils/GetFixedAndStickyHeight.js'
import GetViewportSize from 'utils/GetViewportSize.js'
import History from 'utils/History.js'
import { param, deparam } from 'utils/Param.js'
import {
  formatAvailability,
  formatSlotsToDays,
} from 'utils/FormatAvailability.js'
import { formatOpenOrClosed } from 'utils/OpenOrClosed.js'
import { capitalize, titleCase } from 'utils/Strings.js'

class Utils {
  constructor() {
    this.capitalize = capitalize
    this.constants = Constants
    this.deparam = deparam
    this.formatAvailability = formatAvailability
    this.formatSlotsToDays = formatSlotsToDays
    this.formatTime = formatTime
    this.getBreakpoint = GetBreakpoint
    this.getDistanceToTopOfPage = getDistanceToTopOfPage
    this.getFixedAndStickyHeight = getFixedAndStickyHeight
    this.getViewportSize = GetViewportSize
    this.history = History
    this.formatOpenOrClosed = formatOpenOrClosed
    this.param = param
    this.titleCase = titleCase
  }

  name() {
    return 'Utils'
  }
}

export default Utils
